import axios from 'axios'
import fileSaver from 'file-saver'
import moment from 'moment'

export default{
  namespaced: true,
  state: {
    properties: null,
    eventTypes: null,
    documentTypes: [],
    events: null,
    eventForEdit: {},
    imagesForEvent: {},
    videosForEvent: {},
    eventToManage: {},
    eventToManageForDisplay: null,
    claims: null,
    claimForEdit: {}
  },
  mutations: {
    updateProperties (state, propertyData) {
      console.log('setting event properties: ' + JSON.stringify(propertyData, null, 2))
      state.properties = propertyData
    },
    updateEventTypes (state, types) {
      console.log('setting event types: ' + JSON.stringify(types, null, 2))
      state.eventTypes = types
    },
    updateDocumentTypes (state, types) {
      console.log('setting document types: ' + JSON.stringify(types, null, 2))
      state.documentTypes = types
    },
    updateEvents (state, events) {
      // console.log('setting events: ' + JSON.stringify(events, null, 2))
      state.events = events
    },
    updateEventForEdit (state, eventForEdit) {
      // console.log('setting event for edit: ' + JSON.stringify(eventForEdit, null, 2))
      state.eventForEdit = eventForEdit
    },
    updateClaims (state, claims) {
      console.log('setting claims: ' + JSON.stringify(claims, null, 2))
      state.claims = claims
    },
    updateClaimForEdit (state, claimForEdit) {
      console.log('setting claim for edit: ' + JSON.stringify(claimForEdit, null, 2))
      state.claimForEdit = claimForEdit
    },
    updateImagesForEvent (state, imagesForEvent) {
      console.log('setting images for Event: ' + JSON.stringify(imagesForEvent, null, 2))
      state.imagesForEvent = imagesForEvent
    },
    updateVideosForEvent (state, videosForEvent) {
      console.log('setting videos for Event: ' + JSON.stringify(videosForEvent, null, 2))
      state.videosForEvent = videosForEvent
    },
    updateEventToManage (state, eventToManage) {
      console.log('setting event to manage: ' + JSON.stringify(eventToManage, null, 2))
      state.eventToManage = eventToManage
    },
    updateEventToManageForDisplay (state, eventToManageForDisplay) {
      console.log('setting eventToManageForDisplay: ' + JSON.stringify(eventToManageForDisplay, null, 2))
      state.eventToManageForDisplay = eventToManageForDisplay
    },
    setIncidentReportRenderOptions (state, { eventId, options }) {
      if (state.eventToManageForDisplay && state.eventToManageForDisplay.id === eventId) {
        state.eventToManageForDisplay = { ...state.eventToManageForDisplay, incidentReportRenderOptions: options }
      }
    }
  },
  actions: {
    async saveEvent ({commit, state, rootState}, newEventData) {
      try {
        console.log('Saving Event with args: ' + JSON.stringify(newEventData, null, 2))
        await axios.post(
          `/api/company/${rootState.userCurrentCompany.companyId}/events/save`, newEventData
        )
          .then(result => commit('updateEventForEdit', newEventData))
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    saveInvolvedPerson ({commit, state, rootState}, args) {
      try {
        console.log('Saving Involved Person with args: ' + JSON.stringify(args.involvedPerson, null, 2))
        return axios.post(
          `/api/company/${rootState.userCurrentCompany.companyId}/events/${args.eventId}/involvedPeople`, { involvedPerson: args.involvedPerson }
        )
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    getInvolvedPeople ({commit, state, rootState}, eventId) {
      console.log(`/api/company/${rootState.userCurrentCompany.companyId}/events/${eventId}/involvedPeople`)
      try {
        return axios.get(
          `/api/company/${rootState.userCurrentCompany.companyId}/events/${eventId}/involvedPeople`
        )
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    getInvolvedPerson ({commit, state, rootState}, args) {
      console.log(`/api/company/${rootState.userCurrentCompany.companyId}/events/${args.eventId}/involvedPeople/${args.personId}`)
      try {
        return axios.get(
          `/api/company/${rootState.userCurrentCompany.companyId}/events/${args.eventId}/involvedPeople/${args.personId}`
        )
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    deleteInvolvedPerson ({commit, state, rootState}, args) {
      console.log(`/api/company/${rootState.userCurrentCompany.companyId}/events/${args.eventId}/involvedPeople/${args.personId}`)
      try {
        return axios.delete(
          `/api/company/${rootState.userCurrentCompany.companyId}/events/${args.eventId}/involvedPeople/${args.personId}`
        )
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    async saveEventProgress ({commit, state, rootState}, saveProgressRequest) {
      try {
        console.log('Saving Event with args: ' + JSON.stringify(saveProgressRequest, null, 2))
        await axios.post(
          `/api/company/${rootState.userCurrentCompany.companyId}/events/${saveProgressRequest.eventProgress.id}/saveProgress`, { eventProgress: saveProgressRequest.eventProgress, convertNumberIfNeeded: saveProgressRequest.convertNumberIfNeeded }
        )
          .then(result => commit('updateEventForEdit', saveProgressRequest.eventProgress))
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    async saveEventDetails ({commit, state, rootState, dispatch}, eventDetailsArgs) {
      try {
        console.log('Saving Event with args: ' + JSON.stringify(eventDetailsArgs, null, 2))
        await axios.post(
          `/api/company/${rootState.userCurrentCompany.companyId}/events/${eventDetailsArgs.eventId}/details`, eventDetailsArgs.details
        )
          .then(result => dispatch('loadEventToManage', eventDetailsArgs.eventId))
          .then(result => dispatch('loadEventToManageForDisplay', eventDetailsArgs.eventId))
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    async saveClaim ({commit, state, rootState}, args) {
      try {
        console.log('Saving Claim with args: ' + JSON.stringify(args, null, 2))
        return await axios.post(
          `/api/company/${rootState.userCurrentCompany.companyId}/events/${args.eventId}/claims`, {InsuranceClaim: args.claim}
        )
          .then(result => {
            commit('updateClaimForEdit', args.claim)
            return result.data
          })
          .catch(error => {
            if(error.response && error.response.status == 400) {
              console.log(error.response.data)
              return error.response.data
            }
          })
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    async createIncidentReport ({commit, state, rootState}, args) {
      try {
        console.log('Creating Incident Report with Args: ' + JSON.stringify(args, null, 2))
        return await axios.post(
          `/api/company/${rootState.userCurrentCompany.companyId}/events/${args.eventId}/createIncidentReport`
        )
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    async saveIncidentReportRenderOptions ({commit, state, rootState}, args) {
      try {
        console.log('Saving RenderOptions with args: ' + JSON.stringify(args, null, 2))
        await axios.post(
          `/api/company/${rootState.userCurrentCompany.companyId}/events/${args.eventId}/incidentreportrenderoptions`, {incidentReportRenderOptions: args.options}
        )
        commit('setIncidentReportRenderOptions', { eventId: args.eventId, options: args.options })
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    async checkIncidentReportProgress ({commit, state, rootState}, { eventId, token }) {
      try {
        return await axios.get(
          `/api/company/${rootState.userCurrentCompany.companyId}/events/${eventId}/checkCreateIncidentReportStatus`,
          { params: { token } }
        )
      } catch (e) {
        console.log(`Error checking incident report progress: ${e.message}`)
      }
    },
    async getIncidentReportHistory ({commit, state, rootState}, { eventId }) {
      try {
        return await axios.get(
          `/api/company/${rootState.userCurrentCompany.companyId}/events/${eventId}/incidentReportHistory`
        )
      } catch (e) {
        console.log(`Error loading incident report history: ${e.message}`)
      }
    },
    async getIncidentReportPreview ({commit, state, rootState}, { eventId, renderOptions }) {
      try {
        return await axios.post(
          `/api/company/${rootState.userCurrentCompany.companyId}/events/${eventId}/incidentreport/preview`,
          renderOptions
        )
      } catch (e) {
        console.log(`Error loading incident report preview: ${e.message}`)
      }
    },
    async createNewEventWithReturnOrig ({commit, state, rootState}, newEventData) {
      return new Promise(
        function (resolve, reject) {
          try {
            console.log('Creating Event with args: ' + JSON.stringify(newEventData, null, 2))
            axios.post(
              `/api/company/${rootState.userCurrentCompany.companyId}/events/create`, newEventData
            )
              .then(result => {
                commit('updateEventForEdit', result.data.eventProgress)
                if (!result.data.eventProgress.procedure) {
                  reject(new Error('Not found'))
                } else {
                  resolve(result)
                }
              }
              )
              .then(result => commit('updateImagesForEvent', []))
              .then(result => commit('updateVideosForEvent', []))
          } catch (e) {
            console.log(
              `Error: the server responded with '${e.response.status}: ${
                e.response.statusText
              }'`
            )
            reject(new Error("didn't work"))
          }
        }
      )
    },
    async createNewEventWithReturn ({commit, state, rootState}, newEventData) {
      const result = await axios.post(
        `/api/company/${rootState.userCurrentCompany.companyId}/events/create`, newEventData
      )
      if (result.data.success) {
        commit('updateEventForEdit', result.data.eventProgress)
        commit('updateImagesForEvent', [])
        commit('updateVideosForEvent', [])
      }
      return result
    },
    async resumeEvent ({commit, state, rootState, dispatch}, eventId) {
      try {
        console.log('Resuming Event with id: ' + eventId)
        return await axios.post(
          `/api/company/${rootState.userCurrentCompany.companyId}/events/${eventId}/resume`, { eventId: eventId }
        ).then(result => {
          commit('updateEventForEdit', result.data.eventProgress)
        })
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    async deleteEvent ({commit, state, rootState, dispatch}, deleteEventRequest) {
      try {
        console.log('deleting Event with id: ' + deleteEventRequest.selectedEventId)
        return await axios.post(
          `/api/company/${rootState.userCurrentCompany.companyId}/events/${deleteEventRequest.eventId}/archive`, deleteEventRequest
        ).then(result => {
          commit('updateEventForEdit', result.data.eventProgress)
        })
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    async loadProperties ({commit, state, rootState}) {
      try {
        await axios.get(
          '/api/company/' + rootState.userCurrentCompany.companyId + '/properties'
        )
          .then(result => commit('updateProperties', result.data.properties))
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    async getLoggedInUserProperties ({commit, state, rootState}) {
      console.log('Getting user properties ******** /api/company/' + rootState.userCurrentCompany.companyId + '/user/properties')
      try {
        return await axios.get(
          '/api/company/' + rootState.userCurrentCompany.companyId + '/user/properties'
        )
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    async getPropertyEventsInProgressMock ({commit, state, rootState}, propertyId) {
      return new Promise(
        function (resolve, reject) {
          resolve({
            eventsInProgress1: [],
            eventsInProgress: [
              {
                id: '1234',
                categoryName: 'Fire',
                typeName: 'Unit',
                dateReported: 'now',
                reportedByName: 'Cameron'
              }
            ]
          })
        }
      )
    },
    async getPropertyEventsInProgress ({commit, state, rootState}, propertyId) {
      console.log(`Getting events in progress /api/company/${rootState.userCurrentCompany.companyId}/events/property/${propertyId}/reportinprogress`)
      try {
        return await axios.get(
          `/api/company/${rootState.userCurrentCompany.companyId}/events/property/${propertyId}/reportinprogress`
        )
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    async getPropertyContacts ({commit, state, rootState}, propertyId) {
      try {
        return await axios.get(
          `/api/company/${rootState.userCurrentCompany.companyId}/property/${propertyId}/poc`
        )
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    async getPropertyVendors ({commit, state, rootState}, propertyId) {
      try {
        return await axios.get(
          `/api/company/${rootState.userCurrentCompany.companyId}/property/${propertyId}/vendors`
        )
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    async loadEventTypes ({commit, state, rootState}) {
      console.log('/api/company/' + rootState.userCurrentCompany.companyId + '/eventTypes')
      try {
        return await axios.get(
          '/api/company/' + rootState.userCurrentCompany.companyId + '/eventTypes'
        )
          .then(result => commit('updateEventTypes', result.data.eventTypes))
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    async getEventTypes ({commit, state, rootState}, request) {
      console.log('/api/company/' + rootState.userCurrentCompany.companyId + '/eventTypes')
      try {
        var requestString = '/api/company/' + rootState.userCurrentCompany.companyId + '/eventTypes'
        if (request != null) {
          var params = { sortBy: request.sortBy, sortDirection: request.sortDirection, search: request.search }
          return axios.get(requestString, {params: params})
        } else {
          return axios.get(requestString)
        }
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    async loadDocumentTypes ({commit, state, rootState}) {
      console.log('/api/company/' + rootState.userCurrentCompany.companyId + '/documentTypes')
      try {
        return await axios.get(
          '/api/company/' + rootState.userCurrentCompany.companyId + '/documentTypes'
        )
          .then(result => commit('updateDocumentTypes', result.data.documentTypes))
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    async getDocumentTypes ({commit, state, rootState}, request) {
      console.log('/api/company/' + rootState.userCurrentCompany.companyId + '/documentTypes')
      try {
        var requestString = '/api/company/' + rootState.userCurrentCompany.companyId + '/documentTypes'
        if (request != null) {
          var params = { sortBy: request.sortBy, sortDirection: request.sortDirection, search: request.search, showArchived: request.showArchived }
          return axios.get(requestString, {params: params})
        } else {
          return axios.get(requestString)
        }
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    async saveDocumentType ({commit, state, rootState, dispatch}, documentType) {
      console.log('Saving document type: ' + JSON.stringify(documentType, null, 2))
      await axios.post(`/api/company/${rootState.userCurrentCompany.companyId}/documentTypes/save`, {name: documentType.name, id: documentType.id, isArchived: documentType.isArchived})
        .catch(e => { this.apiMessage = `Error: the server responded with '${e.response.status}: ${e.response.statusText}'` })
    },
    async loadEvents ({commit, state, rootState}) {
      console.log('/api/company/' + rootState.userCurrentCompany.companyId + '/events')
      try {
        await axios.get(
          '/api/company/' + rootState.userCurrentCompany.companyId + '/events'
        )
          .then(result => commit('updateEvents', result.data.events))
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    async getEvents ({commit, state, rootState}, request) {
      console.log('/api/company/' + rootState.userCurrentCompany.companyId + '/events2')

      var requestString = `/api/company/${rootState.userCurrentCompany.companyId}/events2`
      try {
        if (request != null) {
          var params = { sortBy: request.sortBy, sortDirection: request.sortDirection, search: request.search, statusType: request.statusType, claimType: request.claimType }
          return axios.get(requestString, {params: params})
        } else {
          return axios.get(requestString)
        }
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    async loadClaims ({commit, state, rootState}, eventId) {
      console.log(`/api/company/${rootState.userCurrentCompany.companyId}/events/${eventId}/claims`)
      try {
        await axios.get(
          `/api/company/${rootState.userCurrentCompany.companyId}/events/${eventId}/claims`
        )
          .then(result => commit('updateClaims', result.data.insuranceClaims))
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    async createNewClaim ({commit, state, rootState}, args) {
      var claim = { 
        claimDateLocal: new Date(),
        claimStatus:0, 
        claimType: 0, 
        totalLoss: 0, 
        adjustment: 0, 
        policyChoices: [], 
        selectedPolicies: [],
        claimPolicies: [],
        policyIds:[],
        selectedPolicyIds: [],
        policyNumber: null,
        policyId: null,
        selectedPolicy: null,
        untrackedPolicy:{
          insuranceCompany: '',
          policyNumber: '',
          adjusterName: '',
          adjusterPhoneNumber: '',
          adjusterEmail: '',
          deductiblePaid: null,
          amountReceived: null
        }
      }
      commit('updateClaimForEdit', claim)
    },
    async loadClaimForEdit ({commit, state, rootState}, args) {
      console.log(`/api/company/${rootState.userCurrentCompany.companyId}/events/${args.eventId}/claims/${args.claimId}`)
      try {
        await axios.get(
          `/api/company/${rootState.userCurrentCompany.companyId}/events/${args.eventId}/claims/${args.claimId}`
        )
          .then(result => {            
            result.data.insuranceClaim.claimDate = moment(result.data.insuranceClaim.claimDate).format('YYYY-MM-DD')
            if(result.data.insuranceClaim.untrackedPolicy == null) {
              result.data.insuranceClaim.untrackedPolicy = {
                insuranceCompany: '',
                policyNumber: '',
                adjusterName: '',
                adjusterPhoneNumber: '',
                adjusterEmail: '',
                deductiblePaid: null,
                amountReceived: null
              }
            }
            if(!Array.isArray(result.data.insuranceClaim.claimPolicies)) {
              result.data.insuranceClaim.claimPolicies = []
            } else {
              result.data.insuranceClaim.claimPolicies = result.data.insuranceClaim.claimPolicies.map(policy => ({
                ...policy,
                deductiblePaid: policy.deductiblePaid != null ? policy.deductiblePaid : null,
                amountReceived: policy.amountReceived != null ? policy.amountReceived : null
              }))
            }
            if(!Array.isArray(result.data.insuranceClaim.policyChoices)) {
              result.data.insuranceClaim.policyChoices = []
            }
            if(!Array.isArray(result.data.insuranceClaim.selectedPolicies) || result.data.insuranceClaim.selectedPolicies.length === 0) {
              result.data.insuranceClaim.selectedPolicies = result.data.insuranceClaim.claimPolicies.map(policy => ({ ...policy }))
            }
            if(!Array.isArray(result.data.insuranceClaim.policyIds)) {
              result.data.insuranceClaim.policyIds = result.data.insuranceClaim.claimPolicies
                .map(policy => policy.policyId)
                .filter(id => id != null)
            }
            if(!Array.isArray(result.data.insuranceClaim.selectedPolicyIds)) {
              result.data.insuranceClaim.selectedPolicyIds = [...result.data.insuranceClaim.policyIds]
            }
            commit('updateClaimForEdit', result.data.insuranceClaim)
          })
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    async loadClaimPolicyChoices ({commit, state, rootState}, args) {
      console.log(`/api/company/${rootState.userCurrentCompany.companyId}/events/${args.eventId}/claims/policyChoices`)
      try {
        const params = args.claimDate ? { claimDate: args.claimDate } : {}
        await axios.get(
          `/api/company/${rootState.userCurrentCompany.companyId}/events/${args.eventId}/claims/policyChoices`,
          { params }
        )
          .then(result => {
            // Update the policyChoices property of the existing claimForEdit object
            const updatedClaim = { ...state.claimForEdit, policyChoices: result.data.policyChoices, containerChoices: result.data.containerChoices || [] }
            commit('updateClaimForEdit', updatedClaim)
          })
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    async loadEventToManage ({commit, state, rootState}, eventId) {
      console.log(`/api/company/${rootState.userCurrentCompany.companyId}/events/${eventId}`)
      try {
        await axios.get(
          `/api/company/${rootState.userCurrentCompany.companyId}/events/${eventId}`
        )
          .then(result => commit('updateEventToManage', result.data.event))
          .then(result => commit('updateImagesForEvent', []))
          .then(result => commit('updateVideosForEvent', []))
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    async loadEventActivityLog ({commit, state, rootState}, eventId) {
      console.log(`/api/company/${rootState.userCurrentCompany.companyId}/events/${eventId}/activity/logs`)
      try {
        return await axios.get(
          `/api/company/${rootState.userCurrentCompany.companyId}/events/${eventId}/activity/logs`
        )
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    async loadEventToManageForDisplay ({commit, state, rootState}, eventId) {
      if (eventId === null) {
        console.log('****Event ID is null, setting display event to null')
        commit('updateEventToManageForDisplay', null)
        return
      }
      console.log(`/api/company/${rootState.userCurrentCompany.companyId}/events/fordisplay/${eventId}`)
      try {
        await axios.get(
          `/api/company/${rootState.userCurrentCompany.companyId}/events/fordisplay/${eventId}`
        )
          .then(result => commit('updateEventToManageForDisplay', result.data.event))
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    uploadDocument ({commit, state, rootState, dispatch}, args) {
      console.log('Upload clicked. for event: ' + args.eventId)
      const file = args.file
      let formData = new FormData()
      formData.append('file', file)
      return axios.post(`${process.env.DOCS_API_URL}api/company/${rootState.userCurrentCompany.companyId}/events/${args.eventId}/documents/${encodeURIComponent(args.name)}/${args.documentTypeId}`, formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).catch(error => {
        console.log(error)
      })
    },
    async downloadDocument ({commit, state, rootState, dispatch}, args) {
      console.log('Upload clicked. for event: ' + args.eventId)
      return axios.get(`${process.env.DOCS_API_URL}api/company/${rootState.userCurrentCompany.companyId}/events/${args.eventId}/documents/${args.documentId}`,
        {
          responseType: 'blob',
          headers: {'accept': 'application/octet-stream'}
        }).then(response => {
        console.log(response)
        fileSaver.saveAs(response.data, args.fileName)
      }).catch(error => {
        console.log(error)
      })
    },
    async loadEventImages ({commit, state, rootState}, eventId) {
      console.log(`/api/company/${rootState.userCurrentCompany.companyId}/events/${eventId}/images`)
      try {
        await axios.get(
          `/api/company/${rootState.userCurrentCompany.companyId}/events/${eventId}/images`
        )
          .then(result => commit('updateImagesForEvent', result.data.images))
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    async getEventImages ({commit, state, rootState}, eventId) {
      console.log(`/api/company/${rootState.userCurrentCompany.companyId}/events/${eventId}/images`)
      try {
        return await axios.get(
          `/api/company/${rootState.userCurrentCompany.companyId}/events/${eventId}/images`
        )
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    async getEventQuestionImages ({commit, state, rootState}, args) {
      console.log(`/api/company/${rootState.userCurrentCompany.companyId}/events/${args.eventId}/questions/${args.questionId}/images`)
      try {
        return await axios.get(
          `/api/company/${rootState.userCurrentCompany.companyId}/events/${args.eventId}/questions/${args.questionId}/images`
        )
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    async uploadMedias ({commit, state, rootState, dispatch}, args) {
      console.log('Upload clicked. for event: ' + args.eventId)
      const files = args.files
      let formData = new FormData()

      for (var i = 0; i < files.length; i++) {
        formData.append('files', files[i])
        console.log('formData: ', formData)
      }
      return axios.post(`${process.env.DOCS_API_URL}api/company/${rootState.userCurrentCompany.companyId}/events/${args.eventId}/medias`, formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then((result) => {
          return {data: result.data}
        })
        .catch(error => {
          console.log(error)
        })
    },
    async uploadMediasForQuestion ({commit, state, rootState, dispatch}, args) {
      console.log('Upload clicked. for event: ' + args.eventId + ' question:' + args.questionId)
      const files = args.files
      let formData = new FormData()

      for (var i = 0; i < files.length; i++) {
        formData.append('files', files[i])
        console.log('formData: ', formData)
      }
      return axios.post(`${process.env.DOCS_API_URL}api/company/${rootState.userCurrentCompany.companyId}/events/${args.eventId}/questions/${args.questionId}/medias`, formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then((result) => {
          return {data: result.data}
        })
        .catch(error => {
          console.log(error)
        })
    },
    async loadEventVideos ({commit, state, rootState}, eventId) {
      console.log(`/api/company/${rootState.userCurrentCompany.companyId}/events/${eventId}/videos`)
      try {
        await axios.get(
          `/api/company/${rootState.userCurrentCompany.companyId}/events/${eventId}/videos`
        )
          .then(result => commit('updateVideosForEvent', result.data.videos))
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    async getEventVideos ({commit, state, rootState}, eventId) {
      console.log(`/api/company/${rootState.userCurrentCompany.companyId}/events/${eventId}/videos`)
      try {
        return await axios.get(
          `/api/company/${rootState.userCurrentCompany.companyId}/events/${eventId}/videos`
        )
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    async getEventDocuments ({commit, state, rootState}, eventId) {
      try {
        return await axios.get(
          `/api/company/${rootState.userCurrentCompany.companyId}/events/${eventId}/documents`
        )
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${e.response.statusText}'`
        )
      }
    },
    async getEventQuestionVideos ({commit, state, rootState}, args) {
      console.log(`/api/company/${rootState.userCurrentCompany.companyId}/events/${args.eventId}/questions/${args.questionId}/videos`)
      try {
        return await axios.get(
          `/api/company/${rootState.userCurrentCompany.companyId}/events/${args.eventId}/questions/${args.questionId}/videos`
        )
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    async getEventQuestionMedia ({commit, state, rootState}, eventId) {
      try {
        return await axios.get(
          `/api/company/${rootState.userCurrentCompany.companyId}/events/${eventId}/question-media`
        )
      } catch (e) {
        const status = e.response ? e.response.status : ''
        const statusText = e.response ? e.response.statusText : ''
        console.log(`Error loading SOP question media: ${status}: ${statusText}`)
      }
    },
    async canUserViewEvent ({commit, state, rootState, dispatch}, eventId) {
      console.log(`/api/company/${rootState.userCurrentCompany.companyId}/events/${eventId}/canuserviewevent`)
      try {
        return await axios.get(
          `/api/company/${rootState.userCurrentCompany.companyId}/events/${eventId}/canuserviewevent`
        ).then(response => {
          console.log(response)
          return response.data
        })
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    async saveDamageRelatedExpenses ({commit, state, rootState}, args) {
      try {
        console.log('Saving Expenses with args: ' + JSON.stringify(args, null, 2))
        return await axios.post(
          `/api/company/${rootState.userCurrentCompany.companyId}/events/${args.eventId}/damages`, { damageRelatedExpenses: args.damageRelatedExpenses }
        ).then(response => {
          return response.data
        })
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    },
    async getDamageRelatedExpenses ({commit, state, rootState}, eventId) {
      console.log(`/api/company/${rootState.userCurrentCompany.companyId}/events/${eventId}/damages`)
      try {
        return await axios.get(
          `/api/company/${rootState.userCurrentCompany.companyId}/events/${eventId}/damages`
        )
          .then(response => {
            return response
          })
      } catch (e) {
        console.log(
          `Error: the server responded with '${e.response.status}: ${
            e.response.statusText
          }'`
        )
      }
    }
  }
}
